import React from 'react';
import { useAppSelector} from "../../creator-presets/DAL/store";

const TagDetails = () => {

    const PresetsByTagData = useAppSelector((store) => store.PresetsByTagData);


    return (
        <h1 className="waves-h1">
            Plugin chains for {PresetsByTagData.tagPage.tagName}
        </h1>

    )
};

export default TagDetails;